import { Section } from '../layout/Section'
import { pillars } from '../../data/pillars'

export function AboutUs() {
    return (
        <Section id="quem-somos" background="light">
            {/* overflow-hidden corta a imagem que sobe demais */}
            <div className="grid lg:grid-cols-2 gap-12 items-center overflow-hidden">
                {/* Image Composition - Fica abaixo em mobile, ao lado em desktop */}
                <div className="order-2 lg:order-1">
                    {/* Image composition: equipe (base) + celular (overlay) */}
                    {/* ====== AJUSTE DE POSIÇÃO ====== */}
                    {/* max-w-xl = tamanho do container (aumente para 2xl se quiser maior) */}
                    <div className="relative w-full max-w-xl mx-auto lg:mx-0">
                        {/* Base: EQUIPE - Fixa, NA FRENTE (z-10) */}
                        <img
                            src="/assets/equipe-reuniao-estrategia-agile-comunicacao-isometrico-alinhado-direita-plug-celular.svg"
                            alt="Equipe em reunião estratégica"
                            className="relative w-full h-auto z-10"
                        />
                        {/* Overlay: CELULAR - Ajustável, ATRÁS (z-0) */}
                        {/* AJUSTE AQUI: top, left/right, scale */}
                        <img
                            src="/assets/smartphone-interface-completa-dashboard-ecommerce-social-alinhado-direita-celular.svg"
                            alt="Dashboard e métricas"
                            className="absolute w-full h-auto z-0"
                            style={{
                                top: '-85%',       // Ajuste: posição vertical
                                right: '-30%',     // Ajuste: posição horizontal
                                transform: 'scale(0.4)',  // Ajuste: tamanho
                            }}
                        />
                    </div>
                </div>

                {/* Text Content - z-20 para cards ficarem ACIMA da imagem */}
                <div className="order-1 lg:order-2 relative z-20">
                    <h2 className="text-3xl md:text-4xl font-bold text-dpxp-dark mb-6">
                        A tecnologia é feita de gente para gente.
                    </h2>

                    <div className="space-y-4 text-dpxp-muted text-lg leading-relaxed mb-8">
                        <p>
                            A DPXP nasceu do encontro de quatro profissionais com um mesmo propósito: <strong className="text-dpxp-dark">humanizar a TI</strong>.
                        </p>
                        <p>
                            Acreditamos que a precisão dos números e a eficiência dos sistemas só ganham vida quando conectadas às verdadeiras relações humanas. Nossa expertise está em transformar processos confusos em trajetórias claras e objetivos alcançáveis.
                        </p>
                        <p>
                            Aqui, o primeiro passo é dado com confiança — mesmo que seja para trás, para ganhar impulso. Somos movidos pela paixão em governança, dados e arquitetura corporativa, sempre com um olhar no futuro e <strong className="text-dpxp-dark">foco na realidade</strong>.
                        </p>
                    </div>

                    {/* Pillars Grid */}
                    <div>
                        <h3 className="text-xl font-semibold text-dpxp-dark mb-4">
                            Nossa atuação é pautada em:
                        </h3>

                        <div className="grid grid-cols-2 gap-3">
                            {pillars.map((pillar) => {
                                const Icon = pillar.icon
                                return (
                                    <div
                                        key={pillar.id}
                                        className="relative z-10 bg-white rounded-xl p-4 border border-dpxp-primary/10 hover:border-dpxp-primary/30 transition-colors shadow-sm"
                                    >
                                        <div className="w-10 h-10 rounded-lg bg-dpxp-primary/10 flex items-center justify-center text-dpxp-primary mb-3">
                                            <Icon className="w-5 h-5" />
                                        </div>
                                        <h4 className="font-bold text-dpxp-dark text-lg mb-1">{pillar.title}</h4>
                                        <p className="text-base text-dpxp-muted">{pillar.description}</p>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}
